import { ThemeEvents } from '@theme/events';

class ProductCashback extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateCashback);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateCashback);
  }

  updateCashback = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newCashback = event.detail.data.html.querySelector(
      `product-cashback[data-product-id="${this.dataset.productId}"] [ref="cashbackText"]`
    ) || event.detail.data.html.querySelector('product-cashback [ref="cashbackText"]');

    const currentCashback = this.querySelector('[ref="cashbackText"]');

    if (!newCashback || !currentCashback) return;

    if (currentCashback.innerHTML !== newCashback.innerHTML) {
      currentCashback.replaceWith(newCashback);
    }
  };
}

if (!customElements.get('product-cashback')) {
  customElements.define('product-cashback', ProductCashback);
}
